// envs manager

const envVars = import.meta.env;

export const envs: ImportMetaEnv = {
  NODE_ENV: envVars?.['NODE_ENV'] || envVars?.['MODE'],
  ...envVars,
};
